import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
var tokenPromises = {};
export var withStripeElementsUnwrapped = function withStripeElementsUnwrapped(StripeForm) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(StripeElementsForm, _Component);

    function StripeElementsForm(props) {
      var _this;

      _classCallCheck(this, StripeElementsForm);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(StripeElementsForm).call(this, props));

      _defineProperty(_assertThisInitialized(_this), "state", {});

      _this.onSetStripePromise = _this.onSetStripePromise.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(StripeElementsForm, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (window.Stripe) {
          this.stripeAvailable();
        } else {
          this.stripeAvailabilityListener = this.stripeAvailable.bind(this);
          document.body.addEventListener('stripeReady', this.stripeAvailabilityListener);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.stripeAvailabilityListener) {
          document.body.removeEventListener('stripeReady', this.stripeAvailabilityListener);
          delete this.stripeAvailabilityListener;
        }

        var tokenPromiseKey = this.state.tokenPromiseKey;

        if (tokenPromiseKey) {
          delete tokenPromises[tokenPromiseKey];
        }
      }
    }, {
      key: "onSetStripePromise",
      value: function onSetStripePromise(stripePromise) {
        var onTokenPromiseKey = this.props.onTokenPromiseKey;
        var tokenPromiseKey = String(Math.random()).substr(2, 10);
        tokenPromises[tokenPromiseKey] = stripePromise;
        onTokenPromiseKey(tokenPromiseKey);
        this.setState({
          tokenPromiseKey: tokenPromiseKey
        });
      }
    }, {
      key: "getCurrentLanguage",
      value: function getCurrentLanguage() {
        var currentLocale = this.props.intl.locale;
        return currentLocale.split('-')[0];
      }
    }, {
      key: "stripeAvailable",
      value: function stripeAvailable() {
        if (this.stripeAvailabilityListener) {
          document.body.removeEventListener('stripeReady', this.stripeAvailabilityListener);
          delete this.stripeAvailabilityListener;
        }

        var stripe = window.Stripe;
        var elements = stripe.elements({
          locale: this.getCurrentLanguage()
        });
        var onLoadingStateChanged = this.props.onLoadingStateChanged;
        onLoadingStateChanged(false);
        this.setState({
          stripe: stripe,
          elements: elements
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            stripe = _this$state.stripe,
            elements = _this$state.elements,
            tokenPromiseKey = _this$state.tokenPromiseKey;
        return React.createElement(StripeForm, _extends({
          stripe: stripe,
          elements: elements,
          tokenPromise: tokenPromiseKey,
          setStripePromise: this.onSetStripePromise
        }, this.props));
      }
    }]);

    return StripeElementsForm;
  }(Component), _defineProperty(_class, "propTypes", {
    intl: intlShape,
    onLoadingStateChanged: PropTypes.func.isRequired,
    onTokenPromiseKey: PropTypes.func.isRequired
  }), _temp;
};
export var withStripeElements = function withStripeElements(StripeForm) {
  return injectIntl(withStripeElementsUnwrapped(StripeForm));
};
export var getTokenPromise = function getTokenPromise(key) {
  return tokenPromises[key];
};
export var isStripeError = function isStripeError(err) {
  return err && err.isStripeError;
};
export var isStripeValidationError = function isStripeValidationError(err) {
  return isStripeError(err) && err.type === 'validation_error';
};